import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import SearchInput from './inputs/search-input'

const TopPanel = ({query, closed, onSearch, onTriggerPast, OnNewLeague}) => {
  const timer = useRef()
  const [panelQuery, setPanelQuery] = useState(query)

  const onChangeSearch = value => {
    setPanelQuery(value)

    clearTimeout(timer.current)
    timer.current = setTimeout(() => onSearch(value), 500)
  }

  return (
    <div className='row align-items-center top-panel'>
      <div className='text-left col-sm-6 col-xs-6'>
        <button className='leagues-button new-league clickable' onClick={OnNewLeague}>New League</button>
      </div>
      <div className='text-right col-sm-3 col-xs-6'>
        <button 
          className={'leagues-button past-leagues clickable' + (closed ? ' active' : '')}
          onClick={() => onTriggerPast(!closed)}
        >
          Past Leagues
        </button>
      </div>
      <div className='col-sm-3 col-xs-12'>
        <SearchInput value={panelQuery} onChange={e => onChangeSearch(e.currentTarget.value)} />
      </div>
    </div>
  )
}

TopPanel.propTypes = {
  query: PropTypes.string.isRequired,
  closed: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
  onTriggerPast: PropTypes.func.isRequired,
  OnNewLeague: PropTypes.func.isRequired,
}

export default TopPanel
